import types from '@/types';

const createCompanyModule = (companyService) => ({
  namespaced: true,
  state: {
    companies: [],
  },

  mutations: {
    [types.SET_COMPANIES](state, companies = []) {
      state.companies = companies;
    },
  },

  actions: {
    [types.GET_COMPANIES]({ commit }) {
      return companyService.getSelectOptions()
        .then((response) => {
          commit(types.SET_COMPANIES, response.data);
        });
    },
  },
});

export default createCompanyModule;



// WEBPACK FOOTER //
// ./src/store/modules/company.js